import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { ProfileUpdate, profileUpdateSchema } from "../schemas/profile.schema";
import { useProfileUpdate } from "../queries/profile.update.queries";
import { toast } from "sonner";
import { useQueryClient } from "@tanstack/react-query";
import { authKeys } from "@/features/auth/queries/auth.queries";

export const useProfile = (user: any) => {
  const { mutateAsync: updateProfile, isPending, error } = useProfileUpdate();

  const queryClient = useQueryClient();
  const form = useForm({
    resolver: zodResolver(profileUpdateSchema),
    defaultValues: {
      firstName: user.firstName,
      lastName: user.lastName,
      instituteName: user.instituteName,
    },
  });

  const onSubmit = async (data: ProfileUpdate) => {
    try {
      await updateProfile(data);

      toast.success("Profile updated successfully");

      await queryClient.invalidateQueries({
        queryKey: authKeys.me(),
      });
    } catch (error) {
      toast.error("Failed to update profile");
    }
  };

  return { form, onSubmit, isPending, error };
};
